// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mf-0";